import { render, staticRenderFns } from "./ForumThread.vue?vue&type=template&id=1140cf94&scoped=true&"
import script from "./ForumThread.vue?vue&type=script&lang=js&"
export * from "./ForumThread.vue?vue&type=script&lang=js&"
import style0 from "./ForumThread.vue?vue&type=style&index=0&id=1140cf94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1140cf94",
  null
  
)

export default component.exports